"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CalendarEventResultModelFactory_1 = __importDefault(require("./factory/CalendarEventResultModelFactory"));
class CalendarEvents {
    constructor(calId, eventsName) {
        this.container = document.getElementById(calId);
        this.eventResultModels = new CalendarEventResultModelFactory_1.default().getEventResultModels();
        this.eventsName = eventsName;
    }
    daySelected(eventParams) {
        const eventResult = {
            bubbles: false,
            detail: this.eventResultModels.Day(eventParams)
        };
        const event = new CustomEvent(this.eventsName.daySelected, eventResult);
        this.container.dispatchEvent(event);
    }
    slotSelected(eventParams) {
        const eventResult = {
            bubbles: false,
            detail: this.eventResultModels.Slot(eventParams)
        };
        const event = new CustomEvent(this.eventsName.slotSelected, eventResult);
        this.container.dispatchEvent(event);
    }
    slotDeselected(eventParams) {
        const eventResult = {
            bubbles: false,
            detail: this.eventResultModels.Slot(eventParams)
        };
        const event = new CustomEvent(this.eventsName.slotDeselected, eventResult);
        this.container.dispatchEvent(event);
    }
    nextDaysClicked(eventParams) {
        const eventResult = {
            bubbles: false,
            detail: this.eventResultModels.VisibleDaysChange(eventParams)
        };
        const event = new CustomEvent(this.eventsName.nextDaysClicked, eventResult);
        this.container.dispatchEvent(event);
    }
    previousDaysClicked(eventParams) {
        const eventResult = {
            bubbles: false,
            detail: this.eventResultModels.VisibleDaysChange(eventParams)
        };
        const event = new CustomEvent(this.eventsName.prevDaysClicked, eventResult);
        this.container.dispatchEvent(event);
    }
}
exports.default = CalendarEvents;
